import React, { useEffect } from 'react';
import './style.scss'
import { CrossIconModalPPP } from '../svgImages';

interface IPublicModalWrapper {
  show: boolean;
  handleClose: () => void;
  children: React.ReactElement;
  wantCloseIcon?: boolean;
  clx?: any;
}

const PublicModalWrapper: React.FC<IPublicModalWrapper> = (props) => {
  const { show, handleClose, children, wantCloseIcon = true, clx = "" } = props;

  useEffect(() => {
    if (show) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [show]);

  return (
    <>
      {show && (
       <>
        <div className={`public-page-modal-wrapper ${clx}`}>
          <section className='public-page-modal-section'>
            {children}
          </section>
          {wantCloseIcon && <div className="close-btn-icon" onClick={handleClose}>
            <CrossIconModalPPP width={20} height={20}/>
          </div>}
        </div> 
        <div className='public-page-modal-backdrop'></div>
       </>
      )}
    </>
  );
};

export default PublicModalWrapper;
